import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import CountUp from 'react-countup';
import { Box, Typography, Button, CardMedia } from '@material-ui/core';
import Seo from 'sharedComponents/Seo';
import Background from 'components/NonAuthHomePage/components/Banner/components/Background';
import { useTranslation } from 'react-i18next';
import { appRoutes } from 'routes';

import useStyles from './useStyles';

const TodaysRates = () => {
  const [rates, setRates] = useState([
    {
      product: '30YrConv',
      rate: 5.99,
      apr: 6.204,
      payment: 2995,
      upfront: 5970,
    },
  ]);

  useEffect(() => {
    fetch('https://bundle-json-rates.s3.amazonaws.com/rates.json', { cache: 'no-store' })
      .then(res => res.json())
      .then(result => {
        setRates(result.products);
      });
  }, []);

  const classes = useStyles();
  const { t } = useTranslation();
  const { rate, apr, payment, upfront } = rates[0];

  return (
    <Box>
      <Background>
        <Box className={classes.container}>
          <Seo title={t('meta.TodaysRates.title')} />
          <Typography className={classes.title} variant="h1">
            {t('components.TodaysRates.title')}
          </Typography>
          <div className={classes.rateBox}>
            <RouterLink to={appRoutes.surveyPath()} className={classes.rateLink}>
              <Typography className={classes.rate} variant="h2">
                <CountUp start={2} end={rate} decimals={3} duration={1} suffix="%" useEasing />
              </Typography>
            </RouterLink>
            <Typography className={classes.label} variant="body2">
              30 Year Fixed &#183; $500,000 Loan
            </Typography>
          </div>
          <Box className={classes.details}>
            <Box className={classes.valueBox}>
              <Typography className={classes.value} variant="h2">
                <CountUp start={2} end={rate} decimals={3} duration={1.2} suffix="%" useEasing />
              </Typography>
              <Typography className={classes.label} variant="body2">
                Interest Rate
              </Typography>
            </Box>
            <Box className={classes.valueBox}>
              <Typography className={classes.value} variant="h2">
                <CountUp start={2} end={apr} decimals={3} duration={1.4} suffix="%" useEasing />
              </Typography>
              <Typography className={classes.label} variant="body2">
                APR
              </Typography>
            </Box>
            <Box className={classes.valueBox}>
              <Typography className={classes.value} variant="h2">
                <CountUp start={0} end={payment} decimals={0} duration={1.6} prefix="$" useEasing separator="," />
              </Typography>
              <Typography className={classes.label} variant="body2">
                Monthly Payment
              </Typography>
            </Box>
            <Box className={classes.valueBox}>
              <Typography className={classes.value} variant="h2">
                <CountUp start={0} end={upfront} decimals={0} duration={1.8} prefix="$" useEasing separator="," />
              </Typography>
              <Typography className={classes.label} variant="body2">
                Upfront Costs
              </Typography>
            </Box>
          </Box>

          <Button to={appRoutes.surveyPath()} component={RouterLink} className={classes.navButton}>
            {t('components.TodaysRates.button')}
          </Button>
          <Button href="https://ericmager.floify.com/" variant="outlined" className={classes.navButtonApply}>
            {t('components.TodaysRates.buttonApply')}
          </Button>
        </Box>
      </Background>
      <Typography className={classes.videoTitle} variant="h1">
        {t('components.TodaysRates.videoTitle')}
      </Typography>
      <div className={classes.videoBlock}>
        <CardMedia
          className={classes.video}
          component="iframe"
          src="https://www.youtube.com/embed/SV1a1nO-AB4?rel=0&controls=0&modestbranding=1"
        />
      </div>
      <Box className={classes.disclousreBox}>
        <Typography className={classes.disclousre} variant="body2">
          {t('components.Footer.description2')}
        </Typography>
      </Box>
    </Box>
  );
};

export default TodaysRates;



// WEBPACK FOOTER //
// ./src/components/TodaysRates/TodaysRates.js